import {IErrorLog, IRouteDefinitionParams, ITableColumn} from "../../../index";
import {AbstractSearch, tpl} from "../AbstractSearch";

export const template = tpl

export class viewModel extends AbstractSearch<IErrorLog> {
    protected readonly TABLE: ITableColumn<IErrorLog>[] = [
        {key: 'Id'},
        {key: 'Message', html: false},
        {key: 'ErrorId', label: 'GUID'},
        {key: 'Method'},
        {key: "Registered", label: 'date'},
        {key: 'CallerId'},
        {key: 'Ip'},
        {key: 'comment', html: false},
        {key: 'CompanyId', label: 'organization', validator: () => this.allOrganizations()},
    ]

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.init()
    }

}
